import FailedInjection from "./FailedInjection.js";

export default class FailedBatchResources{
    /** @type {string} */
    batchId;
    /** @type {string} */
    batchName;
    /** @type {FailedInjection[]} */
    failedNestedResources;

    /**
     * @param {string} id
     * @param {string} name
     * @param {FailedInjection[]} failedNestedResources
     */
    constructor(id, name, failedNestedResources) {
        this.batchId = id;
        this.batchName = name;
        this.failedNestedResources = failedNestedResources;
    }

    /** @returns {boolean} */
    isBatchFailed(){
        return this.failedNestedResources.length === 0;
    }

    /**
     * @param json
     * @returns {FailedBatchResources}
     */
    static parseServerJson(json){
        return new FailedBatchResources(json.id, json.name, FailedInjection.parseServerJsonMany(json.failedNestedResources))
    }

    /**
     * @param json
     * @returns {FailedBatchResources[]}
     */
    static parseServerJsonMany(json) {
        return json.map(j => (FailedBatchResources.parseServerJson(j)));
    }
}